import { Routes, Route, Navigate } from "react-router-dom";
import NotFoundPage from "./404";
import { HomePage } from "./home";
import { MainLayout } from "./layouts/main";
import PrivacyPage from "./privacy";
import { GlobalStyle } from "./styles/GlobalStyle";

export const App = () => {

  return (
    <>
      <GlobalStyle />

      <Routes>
        <Route path="/" element={<MainLayout children={<HomePage />} />} />
        <Route path="/politica-de-privacidade" element={<MainLayout children={<PrivacyPage />} />} />
        <Route path="/termos-de-uso" element={<Navigate to="/politica-de-privacidade" />} />
        <Route path="/dados-do-usuario" element={<Navigate to="/politica-de-privacidade" />} />
        <Route path="*" element={<Navigate to="/404" />} />
        <Route path="/404" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};
